import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { AddToCalendar } from "./AddToCalendar";

function whatsappHref(template, success, r) {
  const message = template.replace("{date}", success.date).replace("{time}", r.time).replace("{url}", success.shareUrl);
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

export function RegistrationSuccess({ r, success, onAnother, sfx = "" }) {
  return (
    <div className="registration-card registration-success" data-testid={`registration-success${sfx}`}>
      <span className="success-badge" aria-hidden="true">✓</span>
      <h3>{r.successHeading}</h3>
      <p>{r.successMeta}</p>
      <div className="success-detail">
        <small>{r.dateLabel}</small>
        <strong>{success.date}</strong>
        <span>{success.tag}</span>
        <span>{r.time} · {r.venue}</span>
      </div>
      <AddToCalendar registrationId={success.id} calendarToken={success.calendarToken} />
      <div className="share-seat" data-testid={`share-seat${sfx}`}>
        <small>{r.share.kicker}</small>
        <a className="share-whatsapp-btn" href={whatsappHref(r.share.message, success, r)} target="_blank" rel="noopener noreferrer" data-testid={`share-whatsapp-btn${sfx}`}>
          <WhatsAppIcon size={18} /> {r.share.button}
        </a>
      </div>
      <button type="button" className="btn btn-dark" onClick={onAnother} data-testid={`register-another-btn${sfx}`}>
        {r.another}
      </button>
    </div>
  );
}
